module.exports = __webpack_public_path__ + "static/action-market-research2-bf0fbd89e7734dde0daf63129237b073.png";